export default __webpack_public_path__ + "static/media/tree.d4f24a01.png";